// types
import { createSlice } from '@reduxjs/toolkit'

// initial state
const initialState = {
    filterdata: [],
    pagination: [],
    sort: [],
    search: []
}

// ==============================|| SLICE - MENU ||============================== //

const setFilterStateAction = (state, action) => {
    const payload = action.payload
    const item = state.filterdata.find((item) => item.key == payload.key)
    if (item == undefined) {
        state.filterdata.push(payload)
    } else {
        item.data = payload.data
    }

}

const setPaginationStateAction = (state, action) => {
    const payload = action.payload
    const item = state.pagination.find((item) => item.key == payload.key)
    if (item == undefined) {
        state.pagination.push(payload)
    } else {
        state.pagination = state.pagination.map((item) => {
            if (item.key == payload.key) {
                return payload
            }
            return item
        })
    }
}

const setSortStateAction = (state, action) => {
    const payload = action.payload
    const item = state.sort.find((item) => item.key == payload.key)
    if (item == undefined) {
        state.sort.push(payload)
    } else {
        state.sort = state.sort.map((item) => {
            if (item.key == payload.key) {
                return payload
            }
            return item
        })
    }
}

const setSearchStateAction = (state, action) => {
    const payload = action.payload
    const item = state.search.find((item) => item.key == payload.key)
    if (item == undefined) {
        state.search.push(payload)
    } else {
        state.search = state.search.map((item) => {
            if (item.key == payload.key) {
                return payload
            }
            return item
        })
    }
}

const listgrid = createSlice({
    name: 'listgrid',
    initialState,
    reducers: {
        setFilterState: setFilterStateAction,
        setPaginationState: setPaginationStateAction,
        setSortState: setSortStateAction,
        setSearchState: setSearchStateAction
    }
})

export default listgrid.reducer

export const { setFilterState, setPaginationState, setSortState, setSearchState } = listgrid.actions
